module.exports = __webpack_public_path__ + "img/promo-fertigen@2x.1d994cb3.png";